export default "__VITE_ASSET__B8WA6gEo__"